<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <el-date-picker v-model="searchdatevalue" :value-format="'yyyy-MM-dd'" style="width: 130px;" size="mini"></el-date-picker>
              ~
              <el-date-picker v-model="searchdateend" :value-format="'yyyy-MM-dd'" style="width: 130px;" size="mini"></el-date-picker>
            </el-col>
            <el-col :span="5" v-if="false">
              <el-select v-model="independentserial" @change="bindGrid()" filterable size="small">
                <el-option v-for="item in idd" :key="item.serialnum"
                           :label="item.dname"
                           :value="item.serialnum">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6" v-if="isFinal">
              比例（销售 {{percents.sale}}%、验光 {{percents.glass}}%、加工 {{percents.process}}%）<el-button @click="cashFormVisible=true;" size="mini">设置</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid()" size="mini">搜索</el-button>
              <el-button type="warning" v-on:click="excelPort" size="mini" v-if="loadexcel">导出</el-button>
            </el-col>
          </el-col>
        </div>
        <el-dialog title="修改分配比例" :visible.sync="cashFormVisible" custom-class="min-dialog" center :close-on-click-modal="false" :modal="true" :append-to-body="true">
          <el-form ref="form2" >
            <el-row>
              <el-col :span="24">
                <el-form-item label="销售" :label-width="formLabelWidth" prop="sale">
                  <el-input-number v-model="percents.sale" style="width:120px;" size="mini" :controls="false" :precision="0" :min="0" :max="100"></el-input-number>%
                </el-form-item>
              </el-col>
            </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="验光" :label-width="formLabelWidth" prop="glass">
                <el-input-number v-model="percents.glass" style="width:120px;" size="mini" :controls="false" :precision="0" :min="0" :max="100"></el-input-number>%
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="加工" :label-width="formLabelWidth" prop="process">
                <el-input-number v-model="percents.process" style="width:120px;" size="mini" :controls="false" :precision="0" :min="0" :max="100"></el-input-number>%
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
              <el-col :span="24">
                <el-button @click="cashFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="setPercents">确 定</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
        <el-table :data="tableData" :height="eltableheight"   show-summary :summary-method="getSummaries" size="mini" :default-sort = "{prop: 'realmoney', order: 'descending'}" border style="width: 100%;">
          <el-table-column  width="60"  label="序号" align="center" fixed>
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column label="姓名" align="left" header-align="center" min-width="120" prop="uname" fixed>
          </el-table-column>
          <el-table-column label="销售" header-align="center" >
            <!--<el-table-column label="开单" align="right" header-align="center" prop="order" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['order']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="开单金额" width="110px" align="right" header-align="center" prop="ordermoney" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['ordermoney']|numeric(2)}}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="退单" align="right" header-align="center" prop="backover" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['backover']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="退单金额" align="right" header-align="center" prop="backovermoney" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['backovermoney']|numeric(2)}}</template>-->
            <!--</el-table-column>-->
            <el-table-column label="人数" class-name="顾客人数"  width="70px" align="right" header-align="center" prop="customer" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['customer']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="单量" class-name="实际单量"  width="70px" align="right" header-align="center" prop="sellnum" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['sellnum']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="销售额" width="100px" align="right" header-align="center" prop="realmoney" sortable>
              <template slot-scope="scope"><span :style="moneyColor">{{scope.row['realmoney']|numeric(2)}}</span></template>
            </el-table-column>
            <el-table-column label="副数" class-name="副数"  width="70px" align="right" header-align="center" prop="realnum" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['realnum']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="客单价" width="90px" align="right" header-align="center" prop="singprice" sortable>
              <template slot-scope="scope">{{scope.row['singprice']|numeric(2)}}</template>
            </el-table-column>
            <el-table-column label="业绩" class-name="销售业绩" width="100px" align="right" header-align="center" prop="meritsorder" sortable>
              <template slot-scope="scope"><span :style="moneyColor">{{scope.row['meritsorder']|numeric(3)}}</span></template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="验光" header-align="center" >
            <!--<el-table-column label="次数" align="right" header-align="center" prop="glass" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['glass']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="仅验光" align="right" header-align="center" prop="glassno" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['glassno']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
            <el-table-column label="业绩" class-name="验光业绩" width="100px" align="right" header-align="center" prop="meritsglass" sortable>
              <template slot-scope="scope"><span :style="moneyColor">{{scope.row['meritsglass']|numeric(3)}}</span></template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="加工" header-align="center" >
            <!--<el-table-column label="次数" align="right" header-align="center" prop="process" sortable>-->
            <!--<template slot-scope="scope">{{scope.row['process']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
            <el-table-column label="业绩" class-name="加工业绩" width="100px" align="right" header-align="center" prop="meritsprocess" sortable>
              <template slot-scope="scope"><span :style="moneyColor">{{scope.row['meritsprocess']|numeric(3)}}</span></template>
            </el-table-column>
          </el-table-column>
          <!--<el-table-column label="质检" align="right" header-align="center" prop="quality" sortable>-->
          <!--<template slot-scope="scope">{{scope.row['quality']|numeric(0)}}</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column label="取镜" align="right" header-align="center" prop="over" sortable>-->
          <!--<template slot-scope="scope">{{scope.row['over']|numeric(0)}}</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column label="次数合计" align="right" header-align="center" prop="total" sortable fixed="right">-->
          <!--<template slot-scope="scope">{{scope.row['total']|numeric(0)}}</template>-->
          <!--</el-table-column>-->
          <el-table-column label="业绩合计" width="100px" align="right" header-align="center" prop="meritstotal" sortable >
            <template slot-scope="scope"><span :style="moneyColor">{{scope.row['meritstotal']|numeric(3)}}</span></template>
          </el-table-column>
          <el-table-column label="好评" header-align="center" >
            <el-table-column label="次" class-name="好评次数" width="60px" align="right" header-align="center" prop="positivereview" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['positivereview']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="比" class-name="好评率" width="60px" align="right" header-align="center" prop="positivereviewpre" sortable>
              <template slot-scope="scope"><span v-if="scope.row['positivereviewpre']>0" :style="percentColor">{{scope.row['positivereviewpre']|numeric(0)}}%</span></template>
            </el-table-column>
          </el-table-column>
            <el-table-column label="1原镜" class-name="原镜度数次数" width="60px" align="right" header-align="center" prop="oldmirrordegree" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['oldmirrordegree']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="2电脑验" class-name="电脑验光次数" width="60px" align="right" header-align="center" prop="computeroptometry" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['computeroptometry']|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="3生物测量"  header-align="center">
              <el-table-column label="次" class-name="生物测量次数" width="60px" align="right" header-align="center" prop="biometric" sortable>
                <template slot-scope="scope"><span :style="numberColor">{{scope.row['biometric']|numeric(0)}}</span></template>
              </el-table-column>
              <el-table-column label="比" class-name="生物测量完成率" width="60px" align="right" header-align="center" prop="biometricyujianpre" sortable>
                <template slot-scope="scope"><span v-if="scope.row['biometricyujianpre']>0" :style="percentColor">{{scope.row['biometricyujianpre']|numeric(0)}}%</span></template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="4眼底照相" header-align="center">
              <el-table-column label="次" class-name="眼底照相次数"  width="60px" align="right" header-align="center" prop="funduscamera" sortable>
                <template slot-scope="scope"><span :style="numberColor">{{scope.row['funduscamera']|numeric(0)}}</span></template>
              </el-table-column>
              <el-table-column label="比" class-name="眼底照相完成率" width="60px" align="right" header-align="center" prop="funduscamerayujianpre" sortable>
                <template slot-scope="scope"><span v-if="scope.row['funduscamerayujianpre']>0" :style="percentColor">{{scope.row['funduscamerayujianpre']|numeric(0)}}%</span></template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="5裂隙灯"  header-align="center">
              <el-table-column label="次" class-name="裂隙灯次数" width="60px" align="right" header-align="center" prop="slitlamp" sortable>
                <template slot-scope="scope"><span :style="numberColor">{{scope.row['slitlamp']|numeric(0)}}</span></template>
              </el-table-column>
              <el-table-column label="比" class-name="裂隙灯完成率" width="60px" align="right" header-align="center" prop="slitlampyujianpre" sortable>
                <template slot-scope="scope">
                  <span v-if="scope.row['slitlampyujianpre']>0" :style="percentColor">{{scope.row['slitlampyujianpre']|numeric(0)}}%</span>
                  <span v-else-if="scope.row['customer']>0" :style="percentColor">0%</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="预检完成率" width="60px" align="right" header-align="center" prop="twoyujianpre" sortable>
              <template slot-scope="scope">
                <span v-if="scope.row['twoyujianpre']>0" :style="percentColor">{{scope.row['twoyujianpre']|numeric(0)}}%</span>
                <span v-else-if="scope.row['customer']>0" :style="percentColor">0%</span>
              </template>
            </el-table-column>
            <!--<el-table-column label="3+4+5" class-name="3项平均值" width="60px" align="right" header-align="center" prop="threeyujianpre" sortable>-->
              <!--<template slot-scope="scope"><span v-if="scope.row['threeyujianpre']>0" :style="percentColor">{{scope.row['threeyujianpre']|numeric(0)}}%</span></template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="眼压" align="right" header-align="center" prop="intraocularpressure" sortable>-->
              <!--<template slot-scope="scope">{{scope.row['intraocularpressure']|numeric(0)}}</template>-->
            <!--</el-table-column>-->
          <el-table-column label="验光" header-align="center" >
            <el-table-column label="次" class-name="验光次数" width="60px" align="right" header-align="center" prop="ygnum" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row['ygnum']|numeric(0)}}</span></template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="item.name" header-align="center" v-for="item in glasscoloum" :key="item.code">
            <el-table-column label="次" :class-name="item.name+'次数'" width="60px" align="right" header-align="center" :prop="item.code" sortable>
              <template slot-scope="scope"><span :style="numberColor">{{scope.row[item.code]|numeric(0)}}</span></template>
            </el-table-column>
            <el-table-column label="比" :class-name="item.name+'完成率'" width="60px" align="right" header-align="center" :prop="item.code+'glassespre'" sortable>
              <template slot-scope="scope"><span v-if="scope.row[item.code+'glassespre']>0" :style="percentColor">{{scope.row[item.code+'glassespre']|numeric(0)}}%</span></template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="验光完成率" width="60px" align="right" header-align="center" prop="yanguangover" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row['yanguangover']>0" :style="percentColor">{{scope.row['yanguangover']|numeric(0)}}%</span>
              <span v-else-if="scope.row['ygnum']>0" :style="percentColor">0%</span>
            </template>
          </el-table-column>

          <el-table-column  label="操作" fixed="right"
            align="center" width="80">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="showDetail(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <Workloaddetail ref="Workloaddetail1" ></Workloaddetail>
      </div>
    </el-col>
  </div>
</template>
<script>

  import { workload,workloadSet,workloadgroupGlasses} from '@/api/set/csagreement';
  import {independentDept} from '@/api/set/dept';
  import Workloaddetail from "./Workloaddetail";

  export default {
    name: 'Workload',
    data() {
      return {
        tablecolumns: [],
        loadexcel: false,
        numberColor: 'color: rgb(155, 155, 155)',
        moneyColor: 'color:  rgb(0, 134, 179)',
        percentColor: 'color: green',
        tableData: [],
        cashFormVisible: false,
        formLabelWidth: '70px',
        eltableheight: '300',
        searchdatevalue: '',//年份
        searchdateend: '',
        independentserial: 'all',
        percents: {sale: 0, glass: 0, process: 0},
        totalygnum: 0,
        // totalyanguangover:0,
        twoyujianpretotal: [0, 0, 0],//预检完成率，裂隙灯，验光
        totaldnyg: 0,
        isFinal: false,
        glasscoloum: [{name: "原镜视力", code: "jjjzsl"}, {name: "裸眼视力", code: "lysl"}, {
          name: "主视眼",
          code: "zsy"
        }, {name: "worth4点", code: "worth"}, {name: "立体视", code: "lts"}, {name: "眼位", code: "yw"}, {
          name: "瞳高",
          code: "tg"
        }],
      }
    },
    props: {
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 store ， 分别对应订单、仓库  等菜单角色
      }
    },
    methods: {
      getPrice(money, num) {
        if (num > 0 && money > 0) {
          return (parseFloat(money) / parseFloat(num));
        }
        return 0;
      },
      showDetail(item) {
        this.$refs.Workloaddetail1.initData(this.searchdatevalue, this.searchdateend, item, this.tableData);
      },
      checkDateSepar() {
        if (!this.searchdatevalue || !this.searchdateend) {
          this.$message({
            message: '日期范围必须选择！',
            type: 'error'
          })
          return false;
        }

        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);
        var preDate = new Date(endDate.getTime() - 92 * 24 * 60 * 60 * 1000);
        var errerMSG = "只能查询三个月范围内的数据！";
        if (startDate <= preDate) {
          this.$message({
            message: errerMSG,
            type: 'error'
          })
          return false;
        } else {
          return true;
        }
      },
      getSummaries(param) {
        var methods = this;
        const {columns, data} = param;
        this.tablecolumns = columns;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0)
            return;
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (!column.property) return;
          if (column.property == 'singprice') {//客单价
            sums[index] = methods.getPrice(sums[index - 1], sums[index - 2]).toFixed(2);
            return;
          } else if (column.property.indexOf('glassespre') > -1) {
            sums[index] = (methods.getPrice(sums[index - 1], methods.totalygnum) * parseFloat(100)).toFixed(0) + "%";
            return;
          } else if (column.property == 'yanguangover') {
            sums[index] = methods.twoyujianpretotal[2];
            // sums[index] = (methods.getPrice(methods.totalyanguangover, methods.totalygnum * 2) * parseFloat(100)).toFixed(0) + "%";
            return;
          } else if (column.property.indexOf('yujianpre') > -1) {//预检的好评比率
            if (column.property == 'twoyujianpre') {
              //预检完成率 sums[index] = ((parseFloat(sums[index - 5].replace('%', '')) + parseFloat(sums[index - 3].replace('%', ''))) / parseFloat(2)).toFixed(0) + "%";
              sums[index] = methods.twoyujianpretotal[0];
            } else if (column.property == 'slitlampyujianpre') {//裂隙灯完成率
              sums[index] = methods.twoyujianpretotal[1];//((parseFloat(sums[index - 2].replace('%', '')) + parseFloat(sums[index - 4].replace('%', '')) + parseFloat(sums[index - 6].replace('%', ''))) / parseFloat(3)).toFixed(0) + "%";
            } else {
              sums[index] = (methods.getPrice(sums[index - 1], methods.totaldnyg) * parseFloat(100)).toFixed(0) + "%";
            }
            return;
          } else if (column.property == 'positivereviewpre') {
            //好评比率
            const valuesSales = data.map(item => Number(item['customer']));
            var totalSales = valuesSales.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = (methods.getPrice(sums[index - 1], totalSales) * parseFloat(100)).toFixed(0) + "%";
            return;
          }
          const values = data.map(item => Number(item[column.property]));

          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.property == 'computeroptometry') {
            methods.totaldnyg = sums[index];
          }
          if (column.property.indexOf('money') > -1) {
            sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(2) : 'N/A';
          } else if (column.property.indexOf('merits') > -1) {
            sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(3) : 'N/A';
          } else {
            sums[index] = sums[index] ? parseInt(sums[index]) : '-';
          }

        });

        return sums;
      },
      setPercents() {
        if (!this.percents.sale || this.percents.sale < 0) this.percents.sale = 0;
        if (!this.percents.glass || this.percents.glass < 0) this.percents.glass = 0;
        if (!this.percents.process || this.percents.process < 0) this.percents.process = 0;
        if (this.percents.sale + this.percents.glass + this.percents.process > 100) {
          this.$message({
            message: '分配比例合计不能超过100！',
            type: 'error'
          })
          return;
        }
        workloadSet(this.percents).then(response => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          })
          this.cashFormVisible = false;
          this.bindGrid();
        })
      },
      emptyItem(uguid, uname) {
        var row = {
          uguid: uguid,
          uname: uname,
          oldmirrordegree: 0,
          biometric: 0,
          funduscamera: 0,
          slitlamp: 0,
          computeroptometry: 0,

          biometricyujianpre: 0,
          funduscamerayujianpre: 0,
          twoyujianpre: 0,
          slitlampyujianpre: 0,
          threeyujianpre: 0,
          yanguangover: 0,

          glass: 0,
          glassno: 0,
          order: 0,
          customer: 0,
          ordermoney: parseFloat(0.00),
          realnum: 0,
          realmoney: parseFloat(0.00),
          backover: 0,
          backovermoney: parseFloat(0.00),
          meritsorder: parseFloat(0.00),//订单绩效金额
          meritsglass: parseFloat(0.00),//验光绩效金额
          meritsprocess: parseFloat(0.00),//加工绩效金额
          meritstotal: parseFloat(0.00),//绩效合计
          process: 0,
          quality: 0,
          over: 0,
          total: 0,
          singprice: 0,//客单价
          sellnum: 0,//订单数量
          positivereview: 0,//好评数
          positivereviewpre: 0,//好评率
        };
        for (let j in this.glasscoloum) {
          var yang = this.glasscoloum[j];
          row[yang.code] = parseFloat(0);
          row[yang.code + 'glassespre'] = parseFloat(0);
        }
        return row;
      },
      bindGrid() {//绑定列表
        if (!this.checkDateSepar()) {
          return;
        }
        this.tableData = []
        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);
        var params = {
          begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate(),
          enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate() + ' 23:59:59',
          independentserial: this.independentserial
        };
        workload(params).then(response => {
          var data = response.data.obj
          var glassData = [];
          this.percents = response.data.set
          for (var i in data) {
            var hasValue = false;
            var item = this.emptyItem(data[i].uguid, data[i].uname);
            for (var j in this.tableData) {
              if (this.tableData[j].uguid == data[i].uguid) {
                item = this.tableData[j];
                hasValue = true;
                break;
              }
            }
            var itemMoney = parseFloat(data[i].money);

            //加工绩效办结的时候 再分配
            if (data[i].componentpath == 'processorder' || data[i].componentpath == 'processorderbackover') {
              var processM = itemMoney * parseFloat(this.percents.process * 0.01);

              if (data[i].processuguid) {//加工单独计算
                var hasProcessguid = false;
                var ProceeItem = this.emptyItem(data[i].processuguid, data[i].processuname);
                for (var j in this.tableData) {
                  if (this.tableData[j].uguid == data[i].processuguid) {
                    hasProcessguid = true;
                    ProceeItem = this.tableData[j];
                    break;
                  }
                }
                ProceeItem['meritsprocess'] += processM;
                ProceeItem['meritstotal'] += processM;
                if (!hasProcessguid) {
                  this.tableData.push(ProceeItem);
                }
              } else {
                //计算给开单人
                item['meritsorder'] += processM;
                item['meritstotal'] += processM;
                if (!hasValue) {
                  this.tableData.push(item);
                }
              }
              continue;
            }

            if (data[i].componentpath == 'backover') {
              data[i].num = -data[i].num;
              data[i].money = -data[i].money;

              item['realmoney'] -= parseFloat(data[i].money);
              item['realnum'] -= data[i].num;
              item['total'] -= 2 * data[i].num;//合计要去掉退单量
              item['backovermoney'] += parseFloat(data[i].money);
            } else if (data[i].componentpath == 'order') {
              item['ordermoney'] += parseFloat(data[i].money);
              item['realmoney'] += parseFloat(data[i].money);
              item['realnum'] += data[i].num;
            }
            var salepercents = parseFloat(this.percents.sale);
            if (data[i].auditguid) {
              glassData.push({
                uguid: data[i].auditguid,
                uname: data[i].auditname,
                money: itemMoney * parseFloat(this.percents.glass) * 0.01
              });
            } else {//没验光单，比例计算给配镜顾问
              salepercents += parseFloat(this.percents.glass);
            }


            item['meritsorder'] += itemMoney * parseFloat(salepercents * 0.01);
            item['meritstotal'] += itemMoney * parseFloat(salepercents * 0.01);
            item[data[i].componentpath] += data[i].num;
            // if (data[i].componentpath == 'glass') {
            //   item['glassno'] += (data[i].num?data[i].num:0)-(data[i].num2 ? data[i].num2 : 0);
            // }
            item['singprice'] = this.getPrice(item.realmoney, item.realnum);//客单价
            if (data[i].componentpath == 'order' || data[i].componentpath == 'backover') {
              item['sellnum'] += parseInt(data[i].num2);
              item['positivereview'] += parseInt(data[i].positivereview);
            }

            item['total'] += data[i].num;
            if (!hasValue)
              this.tableData.push(item);
          }
          workloadgroupGlasses(params).then(respGlass => {
            var glasss = [];
            if (respGlass.data.code == 0) {
              glasss = respGlass.data.obj;
            }
            this.totalygnum = 0;
            // this.totalyanguangover = 0;
            this.twoyujianpretotal = ['', '', ''];
            var customerNumTotal = 0;
            var jianpreNumTotal = [0, 0, 0];
            var ygnumtotal = 0;

            //计算预检的比率
            for (let i = 0; i < this.tableData.length; i++) {
              var item = this.tableData[i];
              customerNumTotal += parseInt(item.customer > 0 ? 1 : 0);
              item.biometricyujianpre = (this.getPrice(item.biometric, item.computeroptometry) * parseFloat(100));
              item.funduscamerayujianpre = (this.getPrice(item.funduscamera, item.computeroptometry) * parseFloat(100));
              //预检完成率 item.twoyujianpre = (item.biometricyujianpre + item.funduscamerayujianpre) / parseFloat(2);
              item.twoyujianpre = this.getPrice(item.biometric + item.funduscamera, item.customer) * parseFloat(50);
              jianpreNumTotal[0] += item.twoyujianpre;
              //item.slitlampyujianpre = (this.getPrice(item.slitlamp, item.computeroptometry) * parseFloat(100));
              item.slitlampyujianpre = (this.getPrice(item.slitlamp, item.customer) * parseFloat(100));
              jianpreNumTotal[1] += item.slitlampyujianpre;
              // item.threeyujianpre = (item.biometricyujianpre + item.funduscamerayujianpre + item.slitlampyujianpre) / parseFloat(3);
              item['positivereviewpre'] = this.getPrice(item['positivereview'], item['customer']) * parseFloat(100);//好评率

              var glasssrow = null;
              for (let j in glasss) {
                if (glasss[j].uguid == item.uguid) {
                  glasssrow = glasss[j];
                  break;
                }
              }
              var ygnum = glasssrow ? glasssrow['num'] : 0;
              item['ygnum'] = ygnum;
              this.totalygnum += ygnum;
              var yanguang = 0;
              for (let j in this.glasscoloum) {
                var yang = this.glasscoloum[j];
                item[yang.code] = glasssrow ? parseInt(glasssrow[yang.code]) : 0;//数量
                item[yang.code + 'glassespre'] = glasssrow ? (this.getPrice(glasssrow[yang.code], ygnum) * parseFloat(100)) : 0;//完成百分比
                // if (yang.code == 'jjjzsl' || yang.code == 'lysl' || yang.code == 'zsy') {
                //   yanguang += item[yang.code];
                // }
                if (yang.code == 'worth' || yang.code == 'lts' || yang.code == 'zsy') {
                  yanguang += item[yang.code];
                }
              }
              // this.totalyanguangover += yanguang;
              // item.yanguangover = (this.getPrice(yanguang, item.customer * 2) * parseFloat(100));
              if (ygnum > 0) {
                ygnumtotal += 1;
                item.yanguangover = (this.getPrice(yanguang, ygnum * 3) * parseFloat(100));
                jianpreNumTotal[2] += item.yanguangover;
              }
            }
            if (customerNumTotal > 0) {
              this.twoyujianpretotal[0] = this.getPrice(jianpreNumTotal[0], customerNumTotal).toFixed(0) + '%';
              this.twoyujianpretotal[1] = this.getPrice(jianpreNumTotal[1], customerNumTotal).toFixed(0) + '%';
            }
            if (ygnumtotal > 0) {
              this.twoyujianpretotal[2] = this.getPrice(jianpreNumTotal[2], ygnumtotal).toFixed(0) + '%';
            }

          });

          //计算验光绩效
          for (let j = 0; j < glassData.length; j++) {
            var hasValue = false;
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].uguid == glassData[j].uguid) {
                hasValue = true;
                this.tableData[i].meritsglass += parseFloat(glassData[j].money);
                this.tableData[i].meritstotal += parseFloat(glassData[j].money);
                break;
              }
            }
            if (!hasValue) {
              this.tableData.push({
                uguid: glassData[j].uguid,
                uname: glassData[j].uname,
                meritsglass: glassData[j].money,
                meritstotal: glassData[j].money
              });
            }
          }


          var th = this.dialogtableHeight(this.$route.query.bimanage ? -10 : 90);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;

        }).catch((error) => {
          console.log(error)
        });
      },

      excelPort() {
        let data = []
        let header1 = []
        let column1 = []
        for (let i in this.tablecolumns) {
          var row = this.tablecolumns[i];
          if (!row.property) continue;
          header1.push(row.className ? row.className : row.label);
          column1.push(row.property);
        }
        for (let i in this.tableData) {
          var row = this.tableData[i];
          var newRow = {};
          for (let j in column1) {
            var col = column1[j];
            if (col == 'uname') {
              newRow['uname'] = row['uname'];
            } else if (col.endsWith('pre')) {
              if ((col == 'twoyujianpre' || col == 'slitlampyujianpre' || col == 'yanguangover') && !row[col] && row["customer"] > 0) {
                newRow[col] = "0%";
              } else {
                newRow[col] = row[col] ? (parseFloat(row[col]).toFixed(0) + "%") : '';
              }
            } else if (col.indexOf('merits')) {
              newRow[col] = row[col] ? (parseFloat(row[col]).toFixed(3)) : '';
            } else if (col.indexOf('money') || col == 'singprice') {
              newRow[col] = row[col] ? (parseFloat(row[col]).toFixed(2)) : '';
            } else {
              newRow[col] = row[col] ? (parseFloat(row[col]).toFixed(0)) : '';
            }
          }
          data.push(newRow)
        }

        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);

        var name = '工作量' + (startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate()) + '至' + (endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate());

        this.$exportExcel(header1, column1, data, name)
      }
    },

    mounted() {
      this.searchdateend = new Date();//当天
      this.searchdatevalue = new Date(this.searchdateend.getFullYear(), this.searchdateend.getMonth(), 1);

      independentDept().then(response => {
        this.idd = response.data.obj
        this.idd.unshift({serialnum: "all", dname: "全部"})
        this.bindGrid();
      })
      this.isFinal = false;
      try {
        if (!this.$route.query.bimanage) {
          this.loadexcel = true;
          if (this.$checkRight("财务")) this.isFinal = true;
        } else {
          this.loadexcel = this.$route.query.excel ? true : false;
        }
      } catch (e) {

      }
    },
    components: {Workloaddetail}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Workload.vue